export const scrollToElement = ({ elementToScroll }: { elementToScroll: Element }): void => {
  elementToScroll.scrollIntoView({ block: 'center', behavior: 'smooth' })
}
